/**
 * Shop the build — links pins on the photo to rows in the parts list.
 *
 * Hovering or focusing either side highlights the other, so the photo and the
 * list read as one object rather than two.
 */
class WerksBuild extends HTMLElement {
  connectedCallback() {
    this.pins = [...this.querySelectorAll('[data-build-pin]')];
    this.cards = [...this.querySelectorAll('[data-build-card]')];
    this.active = null;

    this.pins.forEach((pin) => {
      const index = pin.dataset.buildPin;
      pin.addEventListener('pointerenter', () => this.activate(index));
      pin.addEventListener('focus', () => this.activate(index));
      pin.addEventListener('click', () => this.jump(index));
    });

    this.cards.forEach((card) => {
      const index = card.dataset.buildCard;
      card.addEventListener('pointerenter', () => this.activate(index));
      card.addEventListener('focusin', () => this.activate(index));
    });

    this.addEventListener('pointerleave', () => this.activate(null));
  }

  activate(index) {
    if (this.active === index) return;
    this.active = index;

    this.pins.forEach((pin) => {
      pin.toggleAttribute('data-active', pin.dataset.buildPin === index);
    });
    this.cards.forEach((card) => {
      card.toggleAttribute('data-active', card.dataset.buildCard === index);
    });
  }

  jump(index) {
    const card = this.cards.find((c) => c.dataset.buildCard === index);
    if (!card) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
    card.querySelector('a')?.focus({ preventScroll: true });
  }
}

if (!customElements.get('werks-build')) {
  customElements.define('werks-build', WerksBuild);
}
